import React, { useState } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/user-1.jpg"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [username, setUsername] = useState("U")

  React.useEffect(() => {
    const userData = localStorage.getItem("user")
    if (userData) {
      try {
        const user = JSON.parse(userData)
        if (user && user.name) {
          setUsername(user.name)
        }
      } catch (e) {
        console.error("Error parsing user:", e)
      }
    }
  }, [])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="rounded-circle header-profile-user bg-primary text-white d-inline-flex align-items-center justify-content-center font-size-16">
            {username.charAt(0).toUpperCase()}
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
            <i className="mdi mdi-account-circle font-size-17 text-muted align-middle me-1" />
            Mon Profil
          </DropdownItem>
          <DropdownItem tag="a" href="#" onClick={(e) => {
            e.preventDefault();
            // Remove token but keep user info for lock screen
            localStorage.removeItem('auth_token');
            localStorage.setItem('isLocked', 'true');
            window.location.href = '/auth-lock-screen';
          }}>
            <i className="mdi mdi-lock-open-outline font-size-17 text-muted align-middle me-1" />
            Verrouiller ({username})
          </DropdownItem>

          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="mdi mdi-power font-size-17 text-muted align-middle me-1 text-danger" />
            <span>Déconnexion</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)